export default function authHeader() {
  let vuex = JSON.parse(localStorage.getItem('vuex'));

  if (vuex && vuex.auth.accessToken) {
    return { Authorization: 'Bearer ' + vuex.auth.accessToken };
  } else {
    return {};
  }
}
